module.exports = __webpack_public_path__ + "style.css";


/*****************
 ** WEBPACK FOOTER
 ** ./styles/index.scss
 ** module id = 596
 ** module chunks = 1
 **/